module.exports = __webpack_public_path__ + "static/media/floral-vines-with-leaves-and-borders-svgrepo-com.7a896c89.svg";